import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
	AfterViewInit,
	Component,
	NgZone,
	OnInit,
	ViewChild,
} from '@angular/core';
import {
	Event as AngularRouterEvent,
	NavigationError,
	Router,
} from '@angular/router';

import { takeWhile, tap } from 'rxjs';


import { LoaderComponent, LoaderContextEnum } from 'ib/internetbank-core/ib-components/loader/loader.component';
import { ScreenModeService } from 'ib/internetbank-core/ib-services/screen-mode.service';
import { VirtualKeyboardService } from 'ib/internetbank-fields/field-components/input-field/keyboard-toggle/virtual-keyboard.service';

import { environment } from '../environments/environment';
import {
	branchName,
	lastCommitHashForBitbuet,
	packageVersion,
} from '../environments/versions';

import { AuthenticationService } from './authorization/authentication.service';
import { CustomValidators } from './common/custom-validation/custom-validators';
import { OperationAmountAsyncValidator } from './common/custom-validation/operation-amount-async.validator';
import { CurrencyRatesServiceService } from './common/services/currency-rates-service.service';
import { LoaderService } from './common/services/loader.service';
import { RouteHistoryService } from './common/services/route-history.service';
import { NspkPageComponent } from './pages-shared/nspk-page/nspk-page.component';
import { OperationLimitService } from './sections/operations/operation-limit.service';
import { WebimChatService } from './shared/chat/webim-chat/webim-chat.service';
import { ConfirmationCodeService } from './shared/confirmation/confirmation-code-old/confirmation-code.service';
import { KeyboardComponent } from './ui/controls/keyboard/keyboard.component';


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.less'],
	providers: [
		{
			provide: APP_BASE_HREF,
			useValue: '/',
		},
		ConfirmationCodeService,
		OperationLimitService,
	],
	standalone: false,
})
export class AppComponent implements OnInit, AfterViewInit {

	@ViewChild('applicationloader', { static: true })
	public applicationLoader: LoaderComponent;
	@ViewChild('pageLoader', { static: true })
	public pageLoader: LoaderComponent;

	@ViewChild(KeyboardComponent, { static: true })
	public keyboard: KeyboardComponent;

	// public position: any;

	public LoaderContext: typeof LoaderContextEnum = LoaderContextEnum;

	public isDevelop = !environment.production;
	public frontendVersion: string = lastCommitHashForBitbuet;
	public frontendBranchName: string = branchName;
	public packageVersion: string = packageVersion;


	constructor(
		private routeHistoryService: RouteHistoryService,
		private router: Router,
		public loaderService: LoaderService,
		public virtualKeyboardService: VirtualKeyboardService,
		private http: HttpClient,
		private zone: NgZone,
		private operationLimitService: OperationLimitService,
		private currencyRatesServiceService: CurrencyRatesServiceService,
		private webimChatService: WebimChatService,
		private screenModeService: ScreenModeService,
		private authenticationService: AuthenticationService,
	) {
		CustomValidators.setHttpClientSrevice(this.http);
		OperationAmountAsyncValidator.setOperationLimitService(this.operationLimitService);
		OperationAmountAsyncValidator.setCurrencyRatesServiceService(this.currencyRatesServiceService);
	}

	public ngOnInit(): void {

		this.routeHistoryService.register();

		this.loaderService.applicationLoader = this.applicationLoader;
		this.loaderService.pageLoader = this.pageLoader;

		this.loaderService.pageLoader.hide();

		this.webimChatService.init();


		this.screenModeService
			.isScreenMobile$
			.pipe(
				tap((isScreenMobile: boolean) => {
					if (location.pathname.startsWith(`/${NspkPageComponent.path}`)) {
						// ничего не предпринимаем
					} else if (isScreenMobile) {
						if (!location.pathname.startsWith('/mobile')) {

							const urlFornavigateByUrl: string = `/mobile${location.pathname}${location.search}`;
							this.router.navigateByUrl(urlFornavigateByUrl);

							this.router.events.pipe(
								takeWhile((e: AngularRouterEvent) => {

									if (e instanceof NavigationError) {
										e.url === urlFornavigateByUrl;

										this.router.navigate(['/mobile']);

										return false;
									}

									return true;
								}),

							)
								.subscribe();
						}
					} else {
						if (location.pathname.startsWith('/mobile')) {
							this.router.navigate(['/']);
						}
					}
				}),
			)
			.subscribe();

	}

	public ngAfterViewInit(): void {
		// document.querySelector('#loaderStart').remove();
	}

	public scrollToTop() {
		window.scrollTo(0, 0);
	}

	public changeDetectorIndicator() {
		// console.log('StartChangeDetection');
	}
}
